export default __webpack_public_path__ + "static/media/img_nexec-colorBkg.fb9b5cb4.png";